import { CgArrowLongRight } from "react-icons/cg";
import { Link } from "react-router-dom";

export const Feature = ({ data }) => {
  return (
    <div className={`grid grid-cols-1 gap-10 cursor-pointer lg:grid-cols-2`}>
      {data.map((item, i) => (
        <div
          className={`hover radial rounded-[20px] p-8 space-y-5 md:space-y-10 md:p-16 md:rounded-[40px]`}
          key={i}
        >
          <img
            src={item.image}
            alt=""
            className="w-full h-40 object-contain md:h-64"
          />
          <div className="text-white space-y-3">
            <h2 className="text-2xl font-semibold duration-300 md:text-3xl">
              {item.name}
            </h2>
            <p>{item.title}</p>
            <Link
              to="https://app.lipana.co.ke/signup"
              className="text-brandColor font-semibold flex flex-row items-center gap-1 hover:gap-3 hover:underline duration-500 cursor-pointer"
            >
              {item.cta}
              <CgArrowLongRight className="text-2xl" />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export const FeatureTwo = ({ data }) => {
  return (
    <div className={`grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3`}>
      {data.map((item, i) => (
        <div
          className={`hover radial rounded-[20px] p-8 space-y-5 md:space-y-10 md:p-8 md:rounded-[40px] md:last-of-type:col-span-2 lg:last-of-type:col-span-1`}
          key={i}
        >
          <img
            src={item.image}
            alt=""
            className="w-full h-40 rounded-[20px] object-contain md:rounded-[40px] md:h-64"
          />
          <div className="text-white space-y-3">
            <h2 className="text-2xl font-semibold duration-300 md:text-3xl">
              {item.name}
            </h2>
            <p>{item.title}</p>

            <Link
              to="https://app.lipana.co.ke/signup"
              className="text-brandColor font-semibold flex flex-row items-center gap-1 hover:gap-3 hover:underline duration-500 cursor-pointer"
            >
              {item.cta}
              <CgArrowLongRight className="text-2xl" />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};
